<template>
   <div>
      <div class="row p-2 mt-4">
         <div class="col-12">
            <span class="custom-span-lg" style="color: #435666;">Configuration
               <i class="fa-solid fa-arrow-right"></i>
            </span>
            <span class="custom-span-no-weight" style="color: #435666;"> &nbsp;DNS over HTTPS Blocking</span>
            <div class="mt-2">
               <small class="text-muted">
                  <i class="fa-solid fa-circle-info me-1" style="color: #00A0C1;"></i>
                  Manage DNS-level blocking and allowing of domains and IPs. Add entries using
                  <strong>domainname.com</strong>, <strong>IP addresses</strong>, <strong>wildcards (*.example.com)</strong>, or <strong>CIDR notation (10.0.0.0/8)</strong>.
               </small>
            </div>
         </div>
      </div>

      <DohBlocking />
   </div>
</template>

<script>
import DohBlocking from '@/components/ExtensionConfiguration/DohBlocking/DohBlocking.vue';

export default {

   components: {
      DohBlocking,
   },

}
</script>

<style scoped>
.custom-span-lg {
   font-size: 24px;
   line-height: 24px;
   font-weight: bold;
}

.custom-span-no-weight {
   font-size: 24px;
   line-height: 24px;
   font-weight: 250;
}
</style>
